import { login_phone } from '@/api';
export default {
  name: "login-phone-no",

  data() {
    return {
      form: {
        phone_area_code: "852",
        phone: "",
        password: ""
      },
      rules: {
        phone: [{
          required: true,
          message: this.$t("Please fill in phone number"),
          trigger: "blur"
        }, {
          type: 'number',
          message: this.$t("Please fill in only number")
        }]
      }
    };
  },

  created() {//if dev mode , fill in the form

    /* if (process.env.NODE_ENV === "development") {
      this.form.phone = 36661580;
      this.form.password = "Kck12345";
    } */
  },

  methods: {
    submitForm(form) {
      this.$refs[form].validate(async valid => {
        if (valid) {
          this.$emit("showErr", false);
          let {
            data
          } = await login_phone(this.form.phone_area_code, this.form.phone + '', this.form.password, "zh-hk");

          if (data.message == "OK") {
            this.$message("Login successfully", {
              type: 'success'
            });

            if (process.env.NODE_ENV !== "development") {
              window.self.location.href = "https://overlander.com.hk/";
            }
          } else {
            this.$emit('showErr', data.message);
          }

          return;
        }
      });
    }

  }
};